(function(){
  if(window.__GTI_TIER_QTY_SPLIT_V3)return;
  window.__GTI_TIER_QTY_SPLIT_V3=1;
  var MAX=5;
  var PROP='_gti_tier_extra';
  var busy=false;
  var skipHook=0;
  if(MAX<=0){
    console.warn('[GTI] tier split disabled (max=0). Re-save promotions in Theme Promo admin.');
    return;
  }
  console.info('[GTI] tier split active, max=', MAX);

  function cartJs(){
    try{ if(typeof window.GTI_PROMO_CART_JS==='string'&&window.GTI_PROMO_CART_JS) return window.GTI_PROMO_CART_JS; }catch(e){}
    try{
      if(typeof Shopify!=='undefined'&&Shopify.routes&&Shopify.routes.root){
        var r=String(Shopify.routes.root);
        if(r.slice(-1)!=='/') r+='/';
        return r+'cart.js';
      }
    }catch(e){}
    return '/cart.js';
  }
  function cartPath(suffix){
    return cartJs().replace(/cart\.js(\?.*)?$/,'cart/'+suffix);
  }
  function getCart(){
    return fetch(cartJs(),{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){
      if(!r.ok) throw new Error('cart');
      return r.json();
    });
  }
  function postJson(url, body){
    skipHook++;
    return fetch(url,{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(body)
    }).then(function(r){
      return r.json().catch(function(){return {};});
    }).finally(function(){ skipHook=Math.max(0,skipHook-1); });
  }
  function isExtra(it){
    var p=(it&&it.properties)||{};
    var v=p[PROP];
    return v===1||v==='1'||v===true||v==='true';
  }
  function notifyCart(){
    try{ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh')); }catch(e){}
    try{ document.documentElement.dispatchEvent(new CustomEvent('cart:updated')); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('theme:cart:change')); }catch(e){}
    try{ if(window.jQuery) jQuery(document).trigger('cart.requestComplete'); }catch(e){}
  }
  function addExtraUnits(variantId, count){
    var n=Math.max(0, Number(count)||0);
    if(!variantId||n<=0) return Promise.resolve();
    var seq=Promise.resolve();
    for(var i=0;i<n;i++){
      seq=seq.then(function(){
        var props={}; props[PROP]='1';
        return postJson(cartPath('add.js'),{items:[{id:Number(variantId),quantity:1,properties:props}]});
      });
    }
    return seq;
  }
  function enforce(){
    if(busy||MAX<=0) return Promise.resolve(false);
    busy=true;
    return getCart().then(function(cart){
      var items=cart.items||[];
      var work=Promise.resolve(false);
      items.forEach(function(it){
        if(isExtra(it)) return;
        var q=Number(it.quantity||0);
        if(q<=MAX) return;
        var overflow=q-MAX;
        var key=it.key;
        var vid=it.variant_id;
        work=work.then(function(){
          return postJson(cartPath('change.js'),{id:key,quantity:MAX}).then(function(res){
            if(res&&res.status===422) throw new Error('change failed');
            return addExtraUnits(vid, overflow).then(function(){ return true; });
          });
        });
      });
      return work;
    }).then(function(changed){
      busy=false;
      if(changed){
        notifyCart();
        return enforce();
      }
      return false;
    }).catch(function(err){
      console.warn('[GTI] tier enforce failed', err);
      busy=false;
      return false;
    });
  }
  function scheduleEnforce(ms){
    setTimeout(function(){ enforce(); }, typeof ms==='number'?ms:200);
  }

  function maybeAfterCartUrl(u){
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(u||''));
  }
  var _fetch=window.fetch;
  if(typeof _fetch==='function'){
    window.fetch=function(){
      var p=_fetch.apply(this,arguments);
      try{
        if(skipHook>0) return p;
        var u=String(arguments[0]&&arguments[0].url?arguments[0].url:arguments[0]||'');
        if(maybeAfterCartUrl(u)){
          p.then(function(){ scheduleEnforce(300); }).catch(function(){});
        }
      }catch(e){}
      return p;
    };
  }
  var _open=XMLHttpRequest.prototype.open;
  var _send=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(method,url){
    this.__gtiTierUrl=String(url||'');
    return _open.apply(this,arguments);
  };
  XMLHttpRequest.prototype.send=function(){
    try{
      if(skipHook<=0&&maybeAfterCartUrl(this.__gtiTierUrl)){
        this.addEventListener('loadend',function(){ scheduleEnforce(300); });
      }
    }catch(e){}
    return _send.apply(this,arguments);
  };

  scheduleEnforce(500);
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ scheduleEnforce(300); });
  }
})();